import { administratorConfigAxios } from '@/utils/api-instance';

export const getAdministradorData = async partner => {
    const api = administratorConfigAxios();
    const { data } = await api.get(`${partner}/`);
    return data;
};
